import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useState } from "react";
const CareersContext = /*#__PURE__*/ createContext({});
export const CareersProvider = ({ children })=>{
    const [search, setSearch] = useState("");
    const [department, setDepartment] = useState(null);
    const [location, setLocation] = useState(null);
    const [positionsPerLocation, setPositionsPerLocation] = useState({});
    const updatePositionsPerLocation = useCallback((positions)=>{
        const numberOfPositionsPerLocation = positions === null || positions === void 0 ? void 0 : positions.reduce((acc, { location })=>{
            acc[location.name] = (acc[location.name] || 0) + 1;
            return acc;
        }, {});
        setPositionsPerLocation(numberOfPositionsPerLocation);
    }, []);
    return /*#__PURE__*/ _jsx(CareersContext.Provider, {
        value: {
            search,
            setSearch,
            department,
            setDepartment,
            location,
            setLocation,
            updatePositionsPerLocation,
            positionsPerLocation
        },
        children: children
    });
};
export const useFilters = ()=>useContext(CareersContext);
